import { FieldsNameVoc } from 'constants/auth/profile-data'
import { STATIC_URL } from 'constants/data'

const initialValues = {
  [FieldsNameVoc.email]: '',
  text: '',
}

const fieldData = {
  cols: 50,
  rows: 6,
  placeholder: 'Задайте ваш вопрос',
}

const imgPath = {
  close: `${STATIC_URL}/filters/icon_close.svg`,
}

export { initialValues, imgPath, fieldData }
